import { useTranslation } from "react-i18next";
import DOMPurify from "dompurify";

export const Larps = () => {
  const { t } = useTranslation();

  const events = t("events.list", { returnObjects: true });

  const cardContent = (event) => (
    <>
      <img className="card-img" src={event.img} alt={event.name} />
      <p className="card-date text-center">{event.date}</p>
      <p
        className="card-title text-center"
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(event.name),
        }}
      />
    </>
  );

  return (
    <div className="container-bg">
      <div className="container">
        <h3 className="container-title">
          {t("events.title")}
        </h3>

        <p>{t("events.intro")}</p>

        <ul className="cards">
          {events.map((event, index) => (
            <li className="card" key={index}>
              {event.link ? (
                <a
                  className="card-link"
                  href={event.link}
                  target="_blank"
                  rel="noreferrer"
                >
                  {cardContent(event)}
                </a>
              ) : (
                cardContent(event)
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};